import { color, Common, device } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Flex } = Common;

interface ThumbnailSkeletonProps {
  height: string;
  width: string;
}

const StreamSkeletonContainer = styled.div`
  border-bottom: solid 1px ${color.gainsboro};
  padding: 20px;

  &:last-child {
    border: none;
  }
`;

const ContentWrapper = styled(Flex).attrs({
  direction: 'column',
  justify: 'center',
})`
  width: 100%;
  gap: 8px;
`;

const LongBar = styled.div`
  background-color: #F7F7F7;
  border-radius: 4px;
  height: 16px;
  width: 100%;
`;

const ShortBar = styled(LongBar)`
  width: 30%;

  @media ${device.tablet} {
    width: 20%;
  }
`;

const Thumbnail = styled(LongBar) < ThumbnailSkeletonProps > `
  border-radius: 6px;
  margin-left: 33px;
  height: 75px;
  width: 100px;
  min-width: 100px;

  @media ${device.tablet} {
    ${({ height, width }) => css`
    height: ${height};
    min-width: ${width};
    width: ${width};
  `}
  }
`;

const StreamSkeletonBox = styled.div`
  border-bottom: 1px solid #ededed;
  padding: 20px;
  position: relative;
  background: #fff;
  display: flex;
`;

const StreamSkeletonLeft = styled.div`
  min-height: 50px;
  width: 50px;
`;

const StreamSkeletonAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: #f7f7f7;
  border-radius: 100%;
`;

const StreamSkeletonRight = styled.div`
  min-height: 50px;
  width: calc(100% - 50px);
  position: relative;
`;

const StreamSkeletonUsername = styled.div`
  width: 100%;
  max-width: 229px;
  height: 16px;
  background: #f7f7f7;
  border-radius: 4px;
`;

const StreamSkeletonDate = styled.div`
  width: 100%;
  max-width: 87px;
  height: 16px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 8px;
`;

const StreamSkeletonContent = styled.div`
  height: 88px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 20px;
`;

export {
  StreamSkeletonContainer,
  ContentWrapper,
  LongBar,
  ShortBar,
  Thumbnail,
  StreamSkeletonBox,
  StreamSkeletonLeft,
  StreamSkeletonAvatar,
  StreamSkeletonRight,
  StreamSkeletonUsername,
  StreamSkeletonDate,
  StreamSkeletonContent,
};
